import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Pret } from '../pret';
import { FormulaireService } from '../formulaire.service';
import { CustomValidators } from '../custom-validators';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { AppGlobal } from '../app.global';
import { environment } from '../../environments/environment';
import { DateUtils } from '../date-utils';

@Component({
  selector: 'app-redirection',
  templateUrl: './redirection.component.html'
})

export class RedirectionComponent implements OnInit {
  
  pretForm: FormGroup;
  companyGroups: any;
  companies: any;
  showCaisseFiliale = false;
  typeSouscriptionList = FormulaireService.typeSouscriptionList;
  typePretList: any;
  usageBienList: any;
  loadingCompanyGroups = false;
  iframe: boolean;
  defaultPret: Pret;

  // template spécial pour le site partenaire Linxea
  linxea: boolean;

  // template spécial pour le site partenaire Aviva
  aviva: boolean;

  apporteur: string;

  capitalRestantControl: any

  @ViewChild('dateSignatureOffreDatePicker') dateSignatureOffreDatePicker: BsDatepickerDirective;

  constructor(private formulaireService: FormulaireService, private router: Router, private fb: FormBuilder, private appGlobal: AppGlobal) {
    this.iframe = appGlobal.isIframe();
  }

  ngOnInit() {
    this.aviva = this.appGlobal.isAviva();
    this.apporteur = environment.codeApporteur;
  }
}



// WEBPACK FOOTER //
// ./src/app/redirection/redirection.component.ts